module.exports = __webpack_public_path__ + "static/img/product.5486e7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/product.jpg
// module id = W0Zd
// module chunks = 0